import React from 'react'
import { i18n } from '../../index'
import { Mutation } from 'react-apollo'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { fetchStation } from '../../station/stationQueries'
import { createExternalEmployee } from '../users/usersQueries'
import css from './externalEmployeeForm.css'

const updateCache =
  (stationId) =>
  (cache: any, { data: { createExternalUser } }: any) => {
    const variables = {
      id: stationId,
    }
    const { station } = cache.readQuery({
      query: fetchStation,
      variables,
    })
    cache.writeQuery({
      query: fetchStation,
      variables,
      data: {
        station: { ...station, users: [...station.users, createExternalUser] },
      },
    })
  }

type ExternalEmployeeFormProps = {
  stationId: string
  onSubmit: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
}
type ExternalEmployeeFormState = {
  employeeName: string
}

class ExternalEmployeeForm extends React.Component<ExternalEmployeeFormProps, ExternalEmployeeFormState> {
  state = {
    employeeName: '',
  }
  onInput = (employeeName: string) => {
    this.setState({
      employeeName,
    })
  }
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { stationId } = this.props
    const { employeeName: name } = this.state
    onMutate({
      variables: {
        data: {
          stationId,
          name,
        },
      },
      update: updateCache(stationId),
    })
    this.props.onSubmit()
    this.onReset()
  }
  onReset = () => {
    this.setState({
      employeeName: '',
    })
  }

  render() {
    const { onCancel } = this.props
    const { employeeName } = this.state
    return (
      <Mutation mutation={createExternalEmployee}>
        {(onMutate) => (
          <form noValidate onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.component}>
            <TextField
              autoFocus
              required
              label={i18n.t('admin.stations.label.employeeName')}
              value={employeeName}
              onChange={(e: any) => this.onInput(e.target.value)}
              className={css.textField}
            />
            <DialogActions className={css.actions}>
              <Button type='button' onClick={onCancel}>
                {i18n.t('buttons.cancel')}
              </Button>
              <Button type='submit' color='primary'>
                {i18n.t('buttons.save')}
              </Button>
            </DialogActions>
          </form>
        )}
      </Mutation>
    )
  }
}

export default ExternalEmployeeForm
